module.exports = __webpack_public_path__ + "img/p2-1.8a184bff.png";